import "core-js/modules/es.array.index-of";
import "core-js/modules/es.object.to-string";
import Vue from 'vue';
import Router from 'vue-router'; // eslint-disable-next-line import/no-cycle

import store from '@/store/index'; // eslint-disable-next-line import/no-cycle

import LoginCongfig from '@/class/login.config'; // import Login from '@/views/Login/index.vue'

var loginInstance = new LoginCongfig();
var isProd = process.env.NODE_ENV === 'production'; // 获取原型对象上的push函数

var originalPush = Router.prototype.push; // 修改原型对象中的push方法

Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(function (err) {});
};

var Login = function Login() {
  return import(
  /* webpackChunkName: "Login" */
  '@/views/Login/index.vue');
};

var ForgetPassword = function ForgetPassword() {
  return import(
  /* webpackChunkName: "ForgetPassword" */
  '@/views/Login/ForgetPassword.vue');
};

var ModifyPassword = function ModifyPassword() {
  return import(
  /* webpackChunkName: "ModifyPassword" */
  '@/views/Login/ModifyPassword.vue');
};

var Home = function Home() {
  return import(
  /* webpackChunkName: "Home" */
  '@/views/Home/index.vue');
};

var Index = function Index() {
  return import(
  /* webpackChunkName: "Index" */
  '@/views/Index/index.vue');
};

var ResetPassword = function ResetPassword() {
  return import(
  /* webpackChunkName: "ResetPassword" */
  '@/views/Login/ResetPassword.vue');
};

var Trialing = function Trialing() {
  return import(
  /* webpackChunkName: "Trialing" */
  '@/views/Trialing/index.vue');
};

var CaseManage = function CaseManage() {
  return import(
  /* webpackChunkName: "CaseManage" */
  '@/views/CaseManage/index.vue');
};

var ScheduleManage = function ScheduleManage() {
  return import(
  /* webpackChunkName: "ScheduleManage" */
  '@/views/ScheduleManage/index.vue');
};

var ScheduleUpdate = function ScheduleUpdate() {
  return import(
  /* webpackChunkName: "ScheduleUpdate" */
  '@/views/ScheduleUpdate/index.vue');
};

var CaseInfo = function CaseInfo() {
  return import(
  /* webpackChunkName: "CaseInfo" */
  '@/views/CaseInfo/index.vue');
};

var CaseCreate = function CaseCreate() {
  return import(
  /* webpackChunkName: "CaseCreate" */
  '@/views/CaseEdit/CaseCreate.vue');
};

var CaseUpdate = function CaseUpdate() {
  return import(
  /* webpackChunkName: "CaseUpdate" */
  '@/views/CaseEdit/CaseUpdate.vue');
};

var DocumentManage = function DocumentManage() {
  return import(
  /* webpackChunkName: "DocumentManage" */
  '@/views/DocumentManage/index.vue');
};

var UploadEvidence = function UploadEvidence() {
  return import(
  /* webpackChunkName: "UploadEvidence" */
  '@/views/UploadEvidence/index.vue');
};

var PersonInfo = function PersonInfo() {
  return import(
  /* webpackChunkName: "PersonInfo" */
  '@/views/PersonInfo/PersonInfo.vue');
};

var Error404 = function Error404() {
  return import(
  /* webpackChunkName: "Error404" */
  '@/views/404.vue');
};

Vue.use(Router);
var router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [{
    path: '/',
    redirect: '/index'
  }, {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: {
      title: '登录'
    }
  }, {
    path: '/forgetPassword',
    name: 'ForgetPassword',
    component: ForgetPassword,
    meta: {
      title: '找回密码'
    }
  }, {
    path: '/modifyPassword',
    name: 'ModifyPassword',
    component: ModifyPassword,
    meta: {
      title: '首次登陆-重置密码'
    }
  }, {
    path: '/resetPassword',
    name: 'ResetPassword',
    component: ResetPassword,
    meta: {
      title: '重置密码'
    }
  }, {
    path: '/index',
    name: 'Index',
    component: Index,
    meta: {
      title: '首页'
    },
    children: [{
      path: '/',
      name: 'Home',
      component: Home,
      meta: {
        title: '首页',
        hasMenu: true
      }
    }, {
      path: '/index/caseInfo/:id',
      name: 'CaseInfo',
      component: CaseInfo,
      meta: {
        title: '案件详情',
        hasMenu: true
      },
      props: true
    }, {
      path: '/index/caseCreate',
      name: 'CaseCreate',
      component: CaseCreate,
      meta: {
        title: '新建案件',
        hasMenu: true
      }
    }, {
      path: '/index/CaseUpdate/:id',
      name: 'CaseUpdate',
      component: CaseUpdate,
      meta: {
        title: '案件编辑',
        hasMenu: true
      },
      props: true
    }, {
      path: '/index/trialing/:scheduleId',
      name: 'Trialing',
      component: Trialing,
      meta: {
        title: '庭审中',
        hasMenu: true
      }
    }, {
      path: '/index/caseManage',
      name: 'CaseManage',
      component: CaseManage,
      meta: {
        keepAlive: true,
        title: '案件管理',
        hasMenu: true
      }
    }, {
      path: '/index/scheduleManage',
      name: 'ScheduleManage',
      component: ScheduleManage,
      meta: {
        title: '排期管理',
        hasMenu: true
      }
    }, {
      path: '/index/scheduleCreate/:caseId',
      name: 'ScheduleUpdate',
      component: ScheduleUpdate,
      meta: {
        title: '新建排期',
        hasMenu: true
      }
    }, {
      path: '/index/scheduleUpdate/:scheduleId',
      name: 'ScheduleUpdate',
      component: ScheduleUpdate,
      meta: {
        title: '编辑排期',
        hasMenu: true
      }
    }, {
      path: '/index/documentManage',
      name: 'DocumentManage',
      component: DocumentManage,
      meta: {
        title: '档案管理',
        hasMenu: true
      }
    }, {
      path: '/index/uploadEvidence/:caseId',
      name: 'UploadEvidence',
      component: UploadEvidence,
      meta: {
        title: '上传证据材料',
        hasMenu: true
      }
    }, {
      path: '/index/personal/info',
      name: 'PersonInfo',
      component: PersonInfo,
      meta: {
        title: '个人中心',
        hasMenu: false
      }
    }]
  }, {
    path: '*',
    name: 'Error404',
    component: Error404,
    meta: {
      title: '无法找到页面'
    }
  }]
}); // 定义路由白名单

var whiteList = ['/login', '/404', '/forgetPassword', '/resetPassword', '/modifyPassword']; // const whiteList: Array< string > = ['/404', '/forgetPassword', '/resetPassword', '/modifyPassword']

function setDocumentTitle(to) {
  var defaultTitle = '音视频互动云平台';

  if (to.meta && to.meta.title) {
    document.title = to.meta.title;
  } else {
    document.title = defaultTitle;
  }
}

function permission(to, from, next) {
  if (whiteList.indexOf(to.path) !== -1) {
    next();
    return;
  }

  if (to.path === '/login') {
    if (store.getters.token) {
      // 若在存在token的情况下，路由为登录时直接进入首页
      // TODO 校验token是否有效
      next({
        path: '/'
      });
    } else {
      next();
    }

    return;
  }

  if (!store.getters.token) {
    // token不存在时，转跳登录
    next('/login'); // if (isProd) {
    //   next('/login')
    // } else {
    //   next()
    // }

    return;
  } // 已存在用户信息时，直接进入路由


  if (store.getters.userInfo.userId) {
    next();
    return;
  } // 拉取user_info


  loginInstance.GetUserInfo().then(function (res) {
    // 判断当前是否有字典
    if (!store.getters.dic.hasGetDic) {
      loginInstance.GetDic().then(function (_) {
        next();
      }).catch(function (_) {
        next();
      });
    } else {
      next();
    }
  }).catch(function (_) {
    store.dispatch('FedLogOut').then(function () {
      next({
        path: '/login'
      });
    });
  });
}

router.beforeEach(function (to, from, next) {
  setDocumentTitle(to);
  permission(to, from, next);
});
export default router;